import { createReducer } from '@reduxjs/toolkit'
import _ from 'underscore'

import {
  clearSummary,
  companyLoggedIn,
  confirmPaymentSelection,
  enablePayment,
  receivedAvailablePaymentTypes,
  resetPaymentMethod,
  resetPaymentSelection,
  selectInvoice,
  selectPaymentMethod,
  updateReferenceNumber
} from '../actions/actions'

export const initialState = {
  availableMethods: {},
  country: 'XZ',
  enabled: false,
  paymentConfirmed: false,
  locale: 'en',
  method: null,
  scrollToOnUpdate: true,
  referenceNumber: '',
  initialized: false
}

const payment = createReducer(initialState, {
  [receivedAvailablePaymentTypes]: (state, { payload }) => {
    const { paymentTypes, country } = payload
    const { paymentServiceProviders } = paymentTypes

    const order = ['SWEDBANK', 'ADYEN', 'KLARNA']

    const orderedMethods = _.sortBy(paymentServiceProviders, provider =>
      order.includes(provider.code) ? order.indexOf(provider.code) : Infinity
    )

    const method = country === 'fi' ? null : orderedMethods[0]?.code

    return {
      ...state,
      availableMethods: orderedMethods,
      method,
      country,
      initialized: true
    }
  },
  [selectPaymentMethod]: (state, { payload }) => {
    state.method = payload
  },
  [selectInvoice]: state => {
    state.method = 'invoice'
  },
  [resetPaymentMethod]: state => {
    const { country, availableMethods } = state
    state.method = country === 'fi' ? null : availableMethods[0]?.code
  },
  [confirmPaymentSelection]: state => {
    state.paymentConfirmed = true
  },
  [resetPaymentSelection]: state => {
    state.paymentConfirmed = false
  },
  [updateReferenceNumber]: (state, { payload }) => {
    state.referenceNumber = payload
  },
  [clearSummary]: state => {
    state.enabled = false
  },
  [enablePayment]: state => {
    state.enabled = true
  },
  [companyLoggedIn]: (state, { payload: { agentRequired } }) => {
    if (agentRequired) {
      state.enabled = false
    }
  }
})

export default payment
